import React, {useRef} from "react";
import "./ElectricGrid.css";


function ElectricGridButton({

state,
setState,
stopGrid,

x=0,
y=0

}) {


const clickTimer = useRef(null);



const handleClick = ()=>{


if(clickTimer.current) return;



clickTimer.current=setTimeout(()=>{


/*
 CLICK SEQUENCE

 STOP  -> START
 START -> PAUSE
 PAUSE -> START

*/


if(state==="STOP"){


setState("START");


}


else if(state==="START"){


setState("PAUSE");


}


else if(state==="PAUSE"){


setState("START");


}



clickTimer.current=null;


},250);



};




const handleDoubleClick = ()=>{


clearTimeout(clickTimer.current);

clickTimer.current=null;



setState("STOP");


if(stopGrid){

stopGrid();

}


};




return (

<button

className={`electric-button ${state}`}

onClick={handleClick}

onDoubleClick={handleDoubleClick}

style={{

position:"absolute",

left:x,

top:y,

zIndex:1000

}}

>

{state}

</button>


);


}


export default ElectricGridButton;